export const selectSiteData = (state) =>
  state.data.sitesetting?.siteSetting?.[0]?.data;

export const selectEnableMaintenance = (state) =>
  state.data.sitesetting?.siteSetting?.[0]?.data?.enableMaintenance;
